import { z } from 'zod'

export const ADMINMETADATAGET_CONTRACT_VERSION = '1.0.0' as const
export const adminMetadataGetResponseSchema = z.unknown()
export type AdminMetadataGetResponse = z.infer<typeof adminMetadataGetResponseSchema>
